<template>
  <div class="main-wrapper scroll-y custom-scrollbar view-user-agreements" style="background: #fff">

    <page-title :title="'Twoje zgody'" :back="false"></page-title>

    <slide-y-up-transition :duration="400" :delay="200">
      <div v-show="show" class="box-info">Drodzy,
        w trosce o bezpieczeństwo i ochronę danych osobowych prosimy
        o zapoznanie się z regulaminem, polityką prywatności oraz o akceptację poniższych zgód.
        Jeżeli chcesz zaktualizować swoje dane osobowe lub kontaktowe możesz to zrobić w zakładce Profil -> Twoje dane
      </div>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="300">
      <div v-if="show">
        <h6 class="text-up">Dokumenty</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <slide-y-up-transition :duration="400" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(url_to_legal)">Regulamin</ion-button>
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(url_to_privacy_policy)">Polityka prywatności</ion-button>
      </div>
    </slide-y-up-transition>

    <slide-x-left-transition :duration="400" :delay="500">
      <div v-if="show">
        <h6 class="text-up">Zgody</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <form-user-agreements></form-user-agreements>

  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import goTo from '@/mixins/goto';
  import PageTitle from '@/components/PageTitle.vue';
  import FormUserAgreements from '@/forms/FormUserAgreements.vue';

  export default {
    name: 'UserAgreements',
    mixins: [goTo],
    components: {PageTitle, FormUserAgreements},
    data() {
      return {
        show: false,
        url_to_legal: 'https://portalgastro.pl/pdf/Portal_Gastro_Regulamin.pdf', // TODO?
        url_to_privacy_policy: 'https://portalgastro.pl/pdf/polityka-prywatnosci.pdf', // TODO?
      }
    },
    mounted() {
      this.$store.commit('profile/PROFILE_SET_HEADER_DISABLED', true);
      this.show = true;
    }
  }
</script>